import { createContext } from "react";
import { InstagramAccountModel } from "@jugl-web/rest-api/integrations/models/InstagramAccount";

export interface InstagramAccountContextType {
  instagramAccount: InstagramAccountModel | undefined;
  isConnected: boolean;
  isConnectingInstagramAccount: boolean;
  loginInstagramAccount: () => void;
}

export const InstagramAccountContext =
  createContext<InstagramAccountContextType | null>(null);
